var _a;
export var StatusEdicaoEnum;
(function (StatusEdicaoEnum) {
    StatusEdicaoEnum["NOVO"] = "NOVO";
    StatusEdicaoEnum["MANTIDO"] = "MANTIDO";
    StatusEdicaoEnum["ATUALIZADO"] = "ATUALIZADO";
    StatusEdicaoEnum["EXCLUIDO"] = "EXCLUIDO";
})(StatusEdicaoEnum || (StatusEdicaoEnum = {}));
export var StatusEdicaoLabels = [
    { label: 'Novo', value: StatusEdicaoEnum.NOVO },
    { label: 'Mantido', value: StatusEdicaoEnum.MANTIDO },
    { label: 'Atualizado', value: StatusEdicaoEnum.ATUALIZADO },
    { label: 'Excluído', value: StatusEdicaoEnum.EXCLUIDO },
];
export var StatusEdicaoConfig = (_a = {},
    _a[StatusEdicaoEnum.NOVO] = {
        label: 'Novo',
        color: '#2E7D32', // Verde
        bgColor: '#E8F5E8',
        icon: 'add_circle',
    },
    _a[StatusEdicaoEnum.MANTIDO] = {
        label: 'Mantido',
        color: '#1976D2', // Azul
        bgColor: '#E3F2FD',
        icon: 'check_circle',
    },
    _a[StatusEdicaoEnum.ATUALIZADO] = {
        label: 'Atualizado',
        color: '#ED6C02', // Laranja
        bgColor: '#FFF3E0',
        icon: 'edit',
    },
    _a[StatusEdicaoEnum.EXCLUIDO] = {
        label: 'Excluído',
        color: '#D32F2F', // Vermelho
        bgColor: '#FFEBEE',
        icon: 'delete',
    },
    _a);
